// @core/api/endpoints/calendar/update_calendar_member_role.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CalendarMemberResponse,
  UpdateCalendarMemberRoleRequest,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Update member role
 * Changes a calendar member's permission level (free-busy, viewer, editor, admin).
 */
export async function UpdateCalendarMemberRole(
  calendar_id: string,
  member_id: string,
  data: UpdateCalendarMemberRoleRequest,
  options?: RequestOptions
): Promise<CalendarMemberResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/calendars/:calendar_id/members/:member_id`;
  requestPath = requestPath.replace(':calendar_id', encodeURIComponent(calendar_id));
  requestPath = requestPath.replace(':member_id', encodeURIComponent(member_id));
  const requestOptions = options;
  return client.put<CalendarMemberResponse>(requestPath, data, requestOptions);
}
